import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

interface EmitOptions {
  column: string;
}

export function useEmitZapListSortEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ column }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ZapListSort,
        optionSelected: column,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return { emit };
}
